import React from 'react';
import PropTypes from 'prop-types';
import Collapsible from 'react-collapsible';
import {
  Header,
  Grid,
  Button,
  Icon,
} from 'semantic-ui-react';

import ActivityLog from './components/ActivityLog';
import ErrorMessage from './components/ErrorMessage';
import MessageContent from './components/MessageContent';
import ConfigurationPanel from './components/ConfigurationPanel';

import './syncPanel.scss';

const initialState = {
  settings: null,
  showSettings: false,
};

class SyncPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }

  componentWillMount = () => {
    const { syncHistory } = this.props;

    this.showSettingsModal(syncHistory);
  }

  componentWillReceiveProps = nextProps => {
    const { syncHistory } = this.props;

    if (syncHistory !== nextProps.syncHistory) {
      this.showSettingsModal(nextProps.syncHistory);
    }
  }

  showSettingsModal = syncHistory => {
    const { showSettings } = this.state;

    if (syncHistory.needSetting && !showSettings) {
      this.handleShowSettings();
    }
  }

  handleShowSettings = () => {
    const { call } = this.props;

    call('GetSettings', json => {
      this.setState({
        settings: json,
        showSettings: true,
      });
    });
  }

  handleHideSettings = () => this.setState({ showSettings: false });

  handleClearSyncError = () => {
    const { call, syncHistory, tick} = this.props;

    call(`ClearSyncError/${syncHistory.syncId}`, (json) => {
      tick();
    });

  }

  render() {
    const {
      call,
      syncHistory,
      syncLogs,
      tick,
      syncError,
    } = this.props;
    const {
      settings,
      showSettings,
    } = this.state;

    return (
      <div>
        { showSettings && (
          <ConfigurationPanel
            call={ call }
            lastFileOffset={ syncHistory.lastFileOffset }
            onClose={ this.handleHideSettings }
            settings={ settings }
          />
        ) }

        { syncLogs && (
          <div>
            <Header size="huge">Sync Log</Header>

            <Grid style={ { marginBottom: 50 } }>
              <Grid.Column width={ 10 }>
                Here&apos;s where you can manage your sync history, along with time and date stamps.
              </Grid.Column>

              <Grid.Column textAlign="right" width={ 6 }>
                <Button onClick={ this.handleShowSettings } primary>
                  <Icon name="settings" /> Configure Settings
                </Button>
              </Grid.Column>
            </Grid>

            { syncError && (
              <ErrorMessage
                call={ call }
                onTryAgain={ this.handleClearSyncError }
                syncError="syncerror"
                text={ `The sync has been paused. ${syncError}` }
                tick={ tick }
              /> ) }

            { syncLogs.elErrors.length > 0 && (
              <Collapsible
                className="mainCollapsible"
                openedClassName="mainCollapsible"
                transitionTime={ 100 }
                trigger={ `Sync Conflicts (${syncLogs.elErrors.length})` }
              >
                <MessageContent
                  call={ call }
                  errorFilter={ [5, 7, 13] }
                  syncLogs={ syncLogs }
                  tick={ tick }
                  triggerText="Customers"
                />

                <MessageContent
                  call={ call }
                  errorFilter={ [2, 3] }
                  syncLogs={ syncLogs }
                  tick={ tick }
                  triggerText="Products and Services"
                />

                <MessageContent
                  call={ call }
                  errorFilter={ [8, 9, 10, 14, 15] }
                  showNumber
                  syncLogs={ syncLogs }
                  tick={ tick }
                  triggerText="Transactions"
                />

                <MessageContent
                  call={ call }
                  errorFilter={ [0, 1, 4, 6, 11, 16] }
                  showNumber
                  syncLogs={ syncLogs }
                  tick={ tick }
                  triggerText="Other"
                />
              </Collapsible> ) }

            <ActivityLog logs={ syncLogs.traces } />
          </div>
        ) }
      </div>
    );
  }
}

SyncPanel.propTypes = {
  syncLogs: PropTypes.shape({
    syncError: PropTypes.string,
    elErrors: PropTypes.arrayOf(PropTypes.shape({
      Error: PropTypes.string,
      ErrorStamp: PropTypes.string,
      QbElementId: PropTypes.number,
      QbElementTypeId: PropTypes.number,
      QbFullname: PropTypes.string,
    })),
    traces: PropTypes.any,
  }).isRequired,
  syncHistory: PropTypes.shape({
    needSetting: PropTypes.bool.isRequired,
  }).isRequired,
  // functions
  call: PropTypes.func.isRequired,
  tick: PropTypes.func.isRequired,
};

export default SyncPanel;



// WEBPACK FOOTER //
// ./src/components/Status/components/SyncPanel/index.js